import { render, staticRenderFns } from "./u-textarea-underlined.vue?vue&type=template&id=5a7483d5&scoped=true&"
import script from "./u-textarea-underlined.vue?vue&type=script&lang=js&"
export * from "./u-textarea-underlined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7483d5",
  null
  
)

export default component.exports